export default function() {

  /**
  * Query the existence of the target element. If the element does not
  * exist, stop executing the function.
  */

  let videos = document.querySelectorAll('.c-video');

  if (!videos) { return; }

  videos.forEach(video => {
    let button = video.querySelector('.c-video__button');
    let videoPlayer = video.querySelector('video');

    if (!button) { return; }
    if (!videoPlayer) {
      button.style.display = 'none';
      return;
    }

    videoPlayer.controls = false;

    button.addEventListener('click', function(e){
      e.preventDefault();
      videoPlayer.play();
      videoPlayer.controls = true;
      button.style.display = 'none';
    });

    videoPlayer.onended = function(){
      videoPlayer.controls = false;
      button.style.display = 'block';
    }
  });
}
